/**
 * Section type constants for DetailPanel and EditPanel
 * Use these constants instead of string literals to prevent typos
 */
export const SECTION_TYPES = {
  LOCATION: "location",
  TRAILER: "trailer",
  TRAILER_STATUS: "trailer-status",
  EQUIPMENT: "equipment",
  NOTES: "notes",
} as const;

export type SectionType = (typeof SECTION_TYPES)[keyof typeof SECTION_TYPES];
